import EmergingMarketArticles from './EmergingMarketArticles';

export default EmergingMarketArticles;
